import { render, staticRenderFns } from "./FinalGradeForm.vue?vue&type=template&id=5ba1ab1a&scoped=true&"
import script from "./FinalGradeForm.vue?vue&type=script&lang=js&"
export * from "./FinalGradeForm.vue?vue&type=script&lang=js&"
import style0 from "./FinalGradeForm.vue?vue&type=style&index=0&id=5ba1ab1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba1ab1a",
  null
  
)

export default component.exports